export default {
  name: 'vnodes',
  functional: true,
  render: (h, ctx) => ctx.props.vnodes,
};
